import { render, staticRenderFns } from "./overview-card.vue?vue&type=template&id=57d50936&scoped=true&"
import script from "./overview-card.vue?vue&type=script&lang=js&"
export * from "./overview-card.vue?vue&type=script&lang=js&"
import style0 from "./overview-card.vue?vue&type=style&index=0&id=57d50936&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d50936",
  null
  
)

export default component.exports